module.exports = __webpack_public_path__ + "img/empty.1d2ca11e.png";